import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import Button from 'gatsby-theme-core/src/components/button/index';
import Plus from 'icons/src/Plus';
import Minus from 'icons/src/Minus';
import Title from './title';

const Item = ({
  children,
  className,
  toggle,
  title,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <div className={className}>
      {toggle && (
        <Toggle
          $title={title}
          $isOpen={open}
          type="button"
          onClick={() => setOpen(!open)}
        >
          <Title>{title} {open ? <Minus /> : <Plus />}</Title>
        </Toggle>
      )}
      {!toggle && (
        <Title>{title}</Title>
      )}
      <Children toggle={toggle} open={open}>
        {children}
      </Children>
    </div>
  );
};

const Children = styled.div`
  @media all and (max-width: ${(props) => props.theme.breakingpoints.lg}) {
    padding-bottom: 1rem;

    ${({ open, toggle }) => !open && toggle && css`
      display none;
    `}
  }
`;

const Toggle = styled(Button).attrs(({ $title, $isOpen }) => ({
  wrapper: true,
  nav: true,
  navType: 'nav_tab',
  menuName: $title,
  eventAction: $isOpen ? 'decrease' : 'increase',
}))`
  display: block;
  width: 100%;
  text-align: left;
  color: inherit;

  @media all and (max-width: ${(props) => props.theme.breakingpoints.lg}) {
    cursor: pointer;
  }

  ${Title} {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    font-size: 1.15rem;

    @media all and (max-width: ${(props) => props.theme.breakingpoints.lg}) {
      margin: 0;
      padding: 1rem 0;
    }
  }

  svg {
    width: 1.25rem;
    height: 1.25rem;
    color: ${({ theme }) => theme.gray3};

    @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
      display: none;
    }
  }
`;

export default styled(Item)`
  background: none;
  border: none;
  text-align: left;
  vertical-align: top;
  padding: 0;
  display: block;
  flex: 1;

  ${({ columns }) => columns && css`
    flex: 2;
  `}


  ${({ toggle }) => toggle && css`

    @media all and (max-width: ${(props) => props.theme.breakingpoints.lg}) {
      border-bottom: 1px solid ${({ theme }) => theme.gray3};
    }
  `}
`;
